<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  name: 'loss-histories-graph',
  data () {
    return {
      options: {
        responsive: false,
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.$t('ai_model_train.epochs')
             }
          }],
          yAxes: [{
            ticks: {
              stepSize: 20,
            }
          }]
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    updateChart(label_epochs, loss_data) {
      this.renderChart({
        labels: label_epochs,
        datasets: [
          {
            label: this.$t('ai_model_train.loss'),
            data: loss_data,
            borderColor: '#6bd098',
            fill: false,
            type: 'line',
            lineTension: 0.2,
          }
        ]
      }, this.options)
    }
  }
}
</script>
